import React, {useState} from "react";
import {Link} from "react-router-dom";
import {Briefcase, Home, Menu, Newspaper, Users, X} from "lucide-react";
import logo from '../assets/photos/Club_Logo.png'; 



const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleScrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <nav className="fixed top-0 left-0 right-0 z-50 p-4">
            <div className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-2xl shadow-xl flex justify-between items-center p-4">
            <div className="flex items-center space-x-2">
                    <img 
                        src={logo} 
                        alt="HealthoTech Logo" 
                        className="h-8 w-8"  // Adjust size as needed
                    />
                <div className="text-2xl font-bold text-white">HealthoTechClub</div>
            </div>

                {/* Desktop Navigation */}
                <div className="hidden md:flex space-x-4">
                    <Link to="/" onClick={handleScrollToTop} className="flex items-center space-x-2 text-white hover:text-blue-200 transition-colors">
                        <Home size={20} />
                        <span>Home</span>
                    </Link>
                    <Link to="/news" onClick={handleScrollToTop} className="flex items-center space-x-2 text-white hover:text-blue-200 transition-colors">
                        <Newspaper size={20} />
                        <span>News</span>
                    </Link>
                    <Link to="/community" onClick={handleScrollToTop}
                          className="flex items-center space-x-2 text-white hover:text-blue-200 transition-colors">
                        <Users size={20}/>
                        <span>Community</span>
                    </Link>
                    <Link to="/career" onClick={handleScrollToTop} className="flex items-center space-x-2 text-white hover:text-blue-200 transition-colors">
                        <Briefcase size={20}/>
                        <span>Career</span>
                    </Link>
                </div>

                {/* Mobile Menu Toggle */}
                <div className="md:hidden">
                    <button
                        onClick={toggleMobileMenu}
                        className="text-white hover:text-blue-200 transition-colors"
                    >
                        {isMobileMenuOpen ? <X size={24}/> : <Menu size={24}/>}
                    </button>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            {isMobileMenuOpen && (
                <div
                    className="md:hidden fixed inset-0 bg-black/80 backdrop-blur-lg z-40 flex flex-col items-center justify-center space-y-6 text-white">
                    <button
                        onClick={toggleMobileMenu}
                        className="absolute top-6 right-6 text-white hover:text-blue-200"
                    >
                        <X size={24} />
                    </button>
                    <Link to="/" onClick={() => {
                            toggleMobileMenu();
                            handleScrollToTop();
                        }}  
                        className="flex items-center space-x-3 text-2xl hover:text-blue-200">
                        <Home size={24} />
                        <span>Home</span>
                    </Link>
                    <Link to="/news" 
                          onClick={() => {
                            toggleMobileMenu();
                            handleScrollToTop();
                        }} 
                          className="flex items-center space-x-3 text-2xl hover:text-blue-200">
                        <Newspaper size={24} />
                        <span>News</span>
                    </Link>
                    <Link to="/community" 
                          onClick={() => {
                            toggleMobileMenu();
                            handleScrollToTop();
                        }}  
                        className="flex items-center space-x-3 text-2xl hover:text-blue-200">
                        <Users size={24} />
                        <span>Community</span>
                    </Link>
                    <Link to="/career" 
                        onClick={() => {
                            toggleMobileMenu();
                            handleScrollToTop();
                        }}  
                        className="flex items-center space-x-3 text-2xl hover:text-blue-200">
                        <Briefcase size={24}/>
                        <span>Career</span>
                    </Link>
                </div>
            )}
        </nav>
    );
};

export default Navbar;